module.exports = __webpack_public_path__ + "img/line_aboute.70b1ab14.png";